export const inr = (n) =>
  `₹${Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 0 })}`;

export const fmtDate = (d) => new Date(d).toISOString().slice(0, 10);

export function nextDays(n, start = 0) {
  const days = [];
  const now = new Date();
  for (let i = start; i < start + n; i++) {
    const d = new Date(now);
    d.setDate(now.getDate() + i);
    days.push(d);
  }
  return days;
}

export const prettyDate = (s) =>
  s ? new Date(s).toLocaleDateString("en-IN", { weekday: "short", day: "numeric", month: "short" }) : "";
